<template>
  <div class="drag">
    <h1>&nbsp;{{strategyName}}&nbsp;[版本{{strategyVersion}}][{{strategyVersionStatus ? '正式' : '草稿'}}]</h1>
    <h1>&nbsp;缓存变量&nbsp;<el-button type="primary" class="el-icon-plus" @click="addVariable"></el-button></h1>
    <el-table :data="variablesData" border stripe highlight-current-row>
      <el-table-column prop="name" label="变量" header-align="center" align="center">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="right">
            <p>名称: {{ scope.row.name }}</p>
            <p>类型: {{ scope.row.dataType === 1 ? '文本' : '数值'}}</p>
            <p>默认: {{ scope.row.defaultValue }}</p>
            <p>描述: {{ scope.row.description }}</p>
            <div slot="reference" class="name-wrapper">
              <span>{{ scope.row.name }}</span>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" @click="editVariable(scope.row)" type="text" size="mini"></el-button>
          <el-button icon="el-icon-delete" @click="removeVariable(scope.row, scope.$index)" type="text" size="mini" style="color: #F56C6C"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="`${ifEdit ? '修改' : '新增'}缓存变量`" :visible.sync="showAddFlag" :before-close="closeDialog" append-to-body>
      <el-form :inline="true" :model="variableForm" :rules="rules" ref="variableForm" label-width="100px" class="demo-form-inline">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form-item label="变量" prop="name">
              <el-input v-model="variableForm.name" placeholder="变量" :disabled="ifEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="类型" prop="dataType">
              <el-select v-model="variableForm.dataType" clearable placeholder="请选择" :disabled="ifEdit">
                <el-option v-for="(item, i) in variableType" :key="i" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form-item label="默认值" prop="defaultValue">
              <el-input v-model="variableForm.defaultValue" placeholder="默认值"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="描述" prop="description">
              <el-input v-model="variableForm.description" placeholder="描述" type="textarea" rows="5" cols="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="30">
            <el-form-item>
              <el-button @click="closeDialog">取消</el-button>
              <el-button type="primary" @click="saveVariable">确定</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import debounce from 'throttle-debounce/debounce'
import {clone} from '@/utils/common'

export default {
  props: {
    strategyId: String,
    strategyName: String,
    strategyVersion: String,
    strategyVersionStatus: Boolean
  },
  data () {
    let validateDefaultValue = (rule, value, callback) => {
      if (value !== '' && isNaN(value) && this.variableForm.dataType === 2) {
        return callback(new Error('请输入正确的数值'))
      }
      return callback()
    }
    return {
      variablesData: [],
      ifEdit: false,
      variableInitForm: {
        strategyId: null,
        name: null,
        dataType: null,
        defaultValue: '',
        description: null
      },
      variableForm: {},
      rules: {
        name: [
          { required: true, message: '请输入变量', trigger: 'blur' }
        ],
        dataType: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        defaultValue: [
          { validator: validateDefaultValue, trigger: 'blur' }
        ]
      },
      variableType: [{value: 1, label: '文本'}, {value: 2, label: '数值'}],
      showAddFlag: false
    }
  },
  watch: {
    strategyId (value, oldValue) {
      this.loadStrategyVariables()
    }
  },
  created () {
    this.loadStrategyVariables()
  },
  methods: {
    closeDialog () {
      this.showAddFlag = false
      this.ifEdit = false
      this.variableForm = clone(this.variableInitForm)
      this.$refs.variableForm.resetFields()
    },
    addVariable () {
      this.showAddFlag = true
      this.ifEdit = false
      this.variableForm = clone(this.variableInitForm)
    },
    editVariable (row) {
      this.showAddFlag = true
      this.ifEdit = true
      this.variableForm = clone(row)
    },
    saveVariable: debounce(300, function () {
      this.$refs.variableForm.validate(async (valid) => {
        if (valid) {
          // 请求后端服务
          try {
            this.variableForm.strategyId = this.strategyId
            let res = this.ifEdit ? await this.$http.put(`/strategy-variable`, this.variableForm) : await this.$http.post(`/strategy-variable`, this.variableForm)
            if (res.code !== '200') {
              this.$message.error(res.message)
              return
            }
            this.loadStrategyVariables()
            this.closeDialog()
            this.$message.success('保存成功')
          } catch (ex) {
            console.info(ex)
            this.$message.error('保存失败')
          }
        }
      })
    }),
    removeVariable: debounce(300, function (row, index) {
      this.$confirm('确认删除吗？', '提示', {type: 'warning'}).then(async () => {
        try {
          // 请求后端服务
          try {
            if (!row.id) {
              this.loadStrategyVariables()
              this.$message.success('删除成功!')
              return
            }
            let res = await this.$http.delete(`/strategy-variable/${this.strategyId}/${row.id}`)
            if (res.code !== '200') {
              this.$message.error(res.message)
              return
            }
            this.variablesData = res.data
            this.loadStrategyVariables()
            this.$message.success('删除成功!')
          } catch (ex) {
            console.info(ex)
            this.loadStrategyVariables()
            this.$message.error('删除失败')
          }
        } catch (err) {
          console.error(err)
        }
      }).catch(action => {
      })
    }),
    async loadStrategyVariables () {
      if (!this.strategyId) return
      try {
        let res = await this.$http.get(`/strategy-variable/${this.strategyId}/list`)
        if (res.code !== '200') {
          this.$message.error(res.message)
          return
        }
        this.variablesData = res.data
        console.info('loadStrategyVariables', res.data)
        this.$emit('getInitializedData', this.variablesData)
      } catch (ex) {
        console.info(ex)
        this.$message.error('获取策略变量数据失败')
      }
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/decisionTree/variable.vue